module.exports = __webpack_public_path__ + "static/media/LTC.47a8d5e7.jpeg";